import { useEffect } from 'react';
import { ProfileContext } from 'r/contexts';
import { isAdminAtom } from 'r/atoms';
import { useSetAtom } from 'jotai';

const ADMIN_ADDRESSES = [
  '0x126f78eef9c5da06838f07e070d369dd042979e6', // clement (new)
  '0x82d61c0931f9d6a84aed8e106f212a69270c9eaa', // agent_phoenix
  '0x5442feef7948775bdbc653d07eb9756d0edddf47', // san_swings
  '0x35adcf84f44a7348889ff8445afd164723837b3b', // the_cash (mqklin duplicate)
  '0x0fc28cd91b175bd9979d1be9a9898b83578e086f', // eugen&
  '0x703bd13f2590091e89f7ec86c4b7505b937e5077', // Holger_Heidrich
  '0xf3f5d550c7280b2919c82b9188d6c3644fb1c3ef', // sanr admin
  '0x35788e05d71edf644771d3eb933b56daf5f0e330', // cyborcat
  '0xc4a85afbdc6012a02e5fd03370949ded7f67c7dc', // no username (issuer e232a0b9)
] as const;

export default function useIsAdmin() {
  const { profile } = ProfileContext.useContext(['profile']);
  const setIsAdmin = useSetAtom(isAdminAtom);

  useEffect(() => {
    const isAdmin = ADMIN_ADDRESSES.includes(profile?.address.toLowerCase());
    setIsAdmin(isAdmin);
  }, [profile, setIsAdmin]);
}
